var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"imgWrap"},[_c('img',{attrs:{"src":_vm.getImgSrc(_vm.path, _vm.name, _vm.is_jpg)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }